module.exports = __webpack_public_path__ + "fonts/iconfont.3dadb35a.woff";